(function ($) {
  var POLL_MS = 100;
  var POLL_MAX = 80;
  var stoqReadyCallbacks = [];
  var stoqReadyFired = false;

  function flushStoqReady() {
    if (stoqReadyFired || !window._RestockRocket) {
      return;
    }
    stoqReadyFired = true;
    stoqReadyCallbacks.splice(0).forEach(function (cb) {
      cb(window._RestockRocket);
    });
  }

  function whenStoqReady(callback) {
    if (window._RestockRocket) {
      callback(window._RestockRocket);
      return;
    }
    stoqReadyCallbacks.push(callback);
    if (stoqReadyCallbacks.length > 1) {
      return;
    }
    window.addEventListener('stoq:loaded', flushStoqReady, { once: true });
    var attempts = 0;
    var timer = window.setInterval(function () {
      if (window._RestockRocket || ++attempts >= POLL_MAX) {
        window.clearInterval(timer);
        flushStoqReady();
      }
    }, POLL_MS);
  }

  function getSelectedVariantId($form) {
    var $select = $form.find('select[name="id"]');
    if (!$select.length) {
      return null;
    }
    return String($select.val() || '');
  }

  function openStoqModal($form) {
    var variantId = getSelectedVariantId($form);
    if (!variantId) {
      return;
    }

    whenStoqReady(function (rr) {
      if (typeof rr.openModal !== 'function') {
        console.warn('[CE] STOQ openModal unavailable — is the STOQ app embed enabled?');
        return;
      }

      var productData = window.stoqProductData;
      var customerData = window.stoqCustomerData || null;

      if (productData) {
        rr.openModal(productData, variantId, customerData);
      } else {
        rr.openModal();
      }
    });
  }

  /** STOQ app embed injects its own button on desktop — do not call renderButtonForVariant there. */
  function removeDuplicateStoqButtons(root) {
    var scope = root || document;
    scope
      .querySelectorAll('.add-to-cart-form.mobile .restock-rocket-button-container')
      .forEach(function (el) {
        el.remove();
      });
  }

  function removeKlaviyoBisNodes(root) {
    var scope = root || document;
    scope.querySelectorAll('#klaviyo-bis-button-container').forEach(function (el) {
      el.remove();
    });
  }

  function watchMobileBagInjections() {
    removeKlaviyoBisNodes();
    removeDuplicateStoqButtons();

    if (!window.MutationObserver) {
      return;
    }

    document.querySelectorAll('.add-to-cart-form.mobile .add-to-bag-container').forEach(function (container) {
      var observer = new MutationObserver(function () {
        removeKlaviyoBisNodes(container);
        removeDuplicateStoqButtons(container);
      });
      observer.observe(container, { childList: true, subtree: true });
    });
  }

  function bindMobileBag($form) {
    $form.find('.stoq-notify-trigger').on('click', function (e) {
      e.preventDefault();
      openStoqModal($form);
    });
  }

  $(function () {
    watchMobileBagInjections();
    $('.add-to-cart-form.mobile').each(function () {
      bindMobileBag($(this));
    });
  });
})(jQuery);
